import { formatNumber, isMasked } from '../misc/sanitizers';

const THOUSANDS = 1000;
const MILLIONS = 1000000;
const BILLIONS = 1000000000;
const TRILLIONS = 1000000000000;

const abbrevs = {
  4: 'K',
  5: 'K',
  6: 'K',
  7: 'M',
  8: 'M',
  9: 'M',
  10: 'B',
  11: 'B',
  12: 'B',
  13: 'T',
  14: 'T',
  15: 'T',
};

const dividerMap = {
  4: THOUSANDS,
  5: THOUSANDS,
  6: THOUSANDS,
  7: MILLIONS,
  8: MILLIONS,
  9: MILLIONS,
  10: BILLIONS,
  11: BILLIONS,
  12: BILLIONS,
  13: TRILLIONS,
  14: TRILLIONS,
  15: TRILLIONS,
};

const fixingMap = {
  6: 1,
  9: 1,
  12: 1,
  15: 1,
};

const deriveDivider = s => (dividerMap[s] ? dividerMap[s] : 1);
const fixValue = s => (!!fixingMap[s] ? 0 : 1);
const makeAbbreviation = s => (!!abbrevs[s] ? abbrevs[s] : '');

export const abbrevNumber = (val, locale = 'en-US', digits = '0.0-2') => {
  if (isMasked(val)) {
    return val;
  }
  const absValue = Math.abs(val);
  const leftSideSize = `${absValue}`.split('.')[0].length;
  if (absValue < 1000) {
    return formatNumber(val, locale, digits);
  }
  const divider = deriveDivider(leftSideSize);
  const abbrev = makeAbbreviation(leftSideSize);
  val = (val / divider).toFixed(fixValue(leftSideSize));
  return `${val != null ? val : '-'}${abbrev != null ? abbrev : ''}`;
};
